var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["sub-values", { inline: !_vm.data.yesNo }] },
    [
      !_vm.data.yesNo
        ? _c("div", { staticClass: "sub-value" }, [
            _c("div", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.data.yesNo === null ? "Egal" : "Nein"))
            ])
          ])
        : [
            _c("div", { staticClass: "sub-value" }, [
              _c("div", { staticClass: "label" }, [_vm._v("Umfang")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("Label", {
                    attrs: {
                      characteristic: _vm.data.scope,
                      "label-type": _vm.labelTypeApplication
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sub-value" }, [
              _c("div", { staticClass: "label" }, [
                _vm._v("Externe Übernachtungen")
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  !_vm.data.externalSleepoverYesNo
                    ? [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.data.externalSleepoverYesNo === null
                                ? "Egal"
                                : "Nein"
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    : _c("Label", {
                        attrs: {
                          characteristic: _vm.data.externalSleepoverScope,
                          "label-type": _vm.labelTypeApplication
                        }
                      })
                ],
                2
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }